import { render, staticRenderFns } from "./BldCatPickBtn.vue?vue&type=template&id=cc1b70ae&scoped=true&"
import script from "./BldCatPickBtn.vue?vue&type=script&lang=js&"
export * from "./BldCatPickBtn.vue?vue&type=script&lang=js&"
import style0 from "./BldCatPickBtn.vue?vue&type=style&index=0&id=cc1b70ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1b70ae",
  null
  
)

export default component.exports